import { jsx as _jsx } from "react/jsx-runtime";
export function CountryFlag({ iso2 }) {
    const codepoints = iso2
        .toUpperCase()
        .split("")
        .map((c) => 0x1f1e6 + c.charCodeAt(0) - 65);
    return (_jsx("span", { "aria-label": `Flag of ${iso2}`, children: String.fromCodePoint(...codepoints) }));
}
